import { Directive } from '@angular/core';

@Directive({
  selector: 'mp-alert-title, [mpAlertTitle]',
  exportAs: 'alertTitle',
})
export class AlertTitleDirective {}

@Directive({
  selector: 'mp-alert-icon, [mpAlertIcon]',
  exportAs: 'alertIcon',
})
export class AlertIconDirective {}
